// extracted by mini-css-extract-plugin
export default {"button":"LogWithPlatform_button__NSE9J","text":"LogWithPlatform_text__0ps7D"};